export const LEFT_HAND_FIST = [
  {t: [-0.0933, -0.0266, -0.1338], r: [0.1346, -0.1437, 0.0038, 0.9804]},
  {t: [-0.0648, -0.0265, -0.1529], r: [0.0354, -0.3351, -0.1786, 0.9244]},
  {t: [-0.0318, -0.0293, -0.1932], r: [0.0407, -0.2202, -0.5685, 0.7916]},
  {t: [-0.0212, -0.0345, -0.2179], r: [0.0132, -0.12, -0.576, 0.8084]},
  {t: [-0.0161, -0.039, -0.2469], r: [0.0132, -0.12, -0.576, 0.8084]},
  {t: [-0.0731, -0.0197, -0.1569], r: [0.0999, -0.2377, 0.0822, 0.9627]},
  {t: [-0.0399, -0.0023, -0.2221], r: [-0.4356, -0.1075, -0.0127, 0.8936]},
  {t: [-0.0325, -0.0319, -0.246], r: [0.9331, 0.066, 0.0832, -0.3436]},
  {t: [-0.035, -0.0462, -0.2296], r: [0.9874, 0.021, 0.128, -0.0903]},
  {t: [-0.0408, -0.0496, -0.2076], r: [0.9874, 0.021, 0.128, -0.0903]},
  {t: [-0.0853, -0.0187, -0.1614], r: [0.115, -0.1594, 0.0889, 0.9765]},
  {t: [-0.0646, -0.0007, -0.2271], r: [-0.4919, -0.1197, 0.0382, 0.8616]},
  {t: [-0.0544, -0.0353, -0.2477], r: [0.9309, 0.1571, 0.0605, -0.324]},
  {t: [-0.0548, -0.0542, -0.2244], r: [0.9835, 0.1315, 0.1097, 0.0583]},
  {t: [-0.0607, -0.051, -0.2013], r: [0.9835, 0.1315, 0.1097, 0.0583]},
  {t: [-0.0972, -0.0213, -0.1628], r: [0.0881, -0.0966, 0.0847, 0.9878]},
  {t: [-0.0856, -0.0088, -0.2263], r: [-0.4818, -0.1075, 0.1033, 0.8635]},
  {t: [-0.0742, -0.0406, -0.246], r: [0.9378, 0.1774, 0.0089, -0.2983]},
  {t: [-0.0715, -0.0585, -0.2205], r: [0.9769, 0.1847, 0.0804, 0.0714]},
  {t: [-0.0757, -0.0552, -0.1994], r: [0.9769, 0.1847, 0.0804, 0.0714]},
  {t: [-0.1078, -0.0253, -0.162], r: [0.0535, -0.0126, 0.0933, 0.9941]},
  {t: [-0.1069, -0.0188, -0.2215], r: [-0.4433, -0.1294, 0.1523, 0.8738]},
  {t: [-0.0939, -0.0444, -0.2398], r: [0.9002, 0.2018, -0.0275, -0.385]},
  {t: [-0.0891, -0.0599, -0.2248], r: [0.9644, 0.2553, 0.0425, -0.0538]},
  {t: [-0.0914, -0.0623, -0.2063], r: [0.9644, 0.2553, 0.0425, -0.0538]},
] as const;

export const RIGHT_HAND_FIST = [
  {t: [0.0504, -0.0155, -0.1083], r: [0.1392, 0.117, -0.058, 0.9816]},
  {t: [0.022, -0.0122, -0.1291], r: [-0.0068, 0.3422, 0.1705, 0.924]},
  {t: [-0.011, -0.019, -0.1691], r: [-0.0952, 0.2257, 0.5977, 0.7634]},
  {t: [-0.0171, -0.0305, -0.1932], r: [-0.249, 0.0162, 0.627, 0.738]},
  {t: [-0.0073, -0.0427, -0.2185], r: [-0.249, 0.0162, 0.627, 0.738]},
  {t: [0.0314, -0.0068, -0.133], r: [0.1126, 0.213, -0.1468, 0.9594]},
  {t: [0.0035, 0.014, -0.1987], r: [-0.5177, 0.1865, 0.0124, 0.8349]},
  {t: [-0.0086, -0.0192, -0.2148], r: [0.9671, -0.1129, -0.1466, -0.1747]},
  {t: [-0.0031, -0.0274, -0.1952], r: [0.9714, -0.0492, -0.2057, 0.1081]},
  {t: [0.0063, -0.0222, -0.1749], r: [0.9714, -0.0492, -0.2057, 0.1081]},
  {t: [0.0441, -0.0073, -0.137], r: [0.1251, 0.1341, -0.1467, 0.972]},
  {t: [0.0283, 0.0126, -0.2028], r: [-0.5227, 0.1469, -0.0852, 0.8354]},
  {t: [0.0144, -0.0224, -0.2202], r: [0.9399, -0.2078, -0.0451, -0.2671]},
  {t: [0.0137, -0.0382, -0.1948], r: [0.9665, -0.181, -0.1188, 0.1381]},
  {t: [0.0207, -0.0318, -0.1726], r: [0.9665, -0.181, -0.1188, 0.1381]},
  {t: [0.0559, -0.0112, -0.1379], r: [0.0948, 0.0732, -0.1351, 0.9836]},
  {t: [0.0482, 0.0022, -0.2011], r: [-0.5015, 0.1223, -0.1588, 0.8416]},
  {t: [0.0337, -0.0294, -0.2191], r: [0.9432, -0.2267, 0.0156, -0.2423]},
  {t: [0.0294, -0.0438, -0.1916], r: [0.9569, -0.2379, -0.08, 0.1464]},
  {t: [0.0346, -0.0376, -0.1714], r: [0.9569, -0.2379, -0.08, 0.1464]},
  {t: [0.0662, -0.0164, -0.1368], r: [0.0546, -0.0084, -0.1349, 0.9893]},
  {t: [0.068, -0.0102, -0.1955], r: [-0.4587, 0.1335, -0.2099, 0.853]},
  {t: [0.0529, -0.0353, -0.2127], r: [0.9107, -0.2444, 0.0606, -0.3274]},
  {t: [0.0466, -0.0483, -0.1959], r: [0.9518, -0.3056, -0.0236, 0.0063]},
  {t: [0.0488, -0.0485, -0.1773], r: [0.9518, -0.3056, -0.0236, 0.0063]},
] as const;
